/* eslint-disable */
import { VehicleCapacity } from "./vehicle-capacity";
import { VehicleConfig } from "./vehicle-config";
import { VehicleType } from "./vehicle-type";

export class VehicleParaPackView {

    vehicleType: VehicleType = new VehicleType();
    vehicleConfig: VehicleConfig = new VehicleConfig();
    vehicleCapacity: VehicleCapacity = new VehicleCapacity();

}
